// extracted by mini-css-extract-plugin
export default {"productGallery":"YI-z","inQuickShop":"ZI-z"};